import React, { useState, useEffect } from 'react';
import StackColumnChart from "../charts/StackColumnChartPartner";
import DualAxesChart from "../charts/DualAxesChart";
import {
  Card,
  Col,
  Row,
  Select,
  Tooltip,
  Slider,
  Empty
} from "antd";

import ReportAPI from "../../services/analyticsService";

import { InfoCircleTwoTone } from "@ant-design/icons";

import "antd/dist/reset.css";
import { recordError } from '../../utils/logService';
import { util } from "../../utils/functions/custom";
import { reportTypeEnum } from '../custom/AppEnums';
import { ReportButtons } from '../custom/ReportButtons';
import { ReportTemplate } from '../custom/ReportTemplate';
import { ReportTemplatePartner } from '../custom/ReportTemplatePartner';
import { DownloadDataAsExcel } from "../custom";

const { Option } = Select;
export const PartnerReport = () => {
  const [initPartnerType, setInitPartnerType] = useState([]);
  const [initPartnerStatus, setInitPartnerStatus] = useState([]);
  const [initPartnerLocality, setInitPartnerLocality] = useState([]);
  const [partnerType, setPartnerType] = useState([]);
  const [partnerStatus, setPartnerStatus] = useState([]);
  const [partnerLocality, setPartnerLocality] = useState([]);
  const [partnerGrowth, setPartnerGrowth] = useState([]);
  const [maxYear, setMaxYear] = useState();
  const [minYear, setMinYear] = useState();
  const [sliderMarks, setSliderMarks] = useState({});
  const [sliderStartIndex, setSliderStartIndex] = useState();
  const [sliderEndIndex, setSliderEndIndex] = useState();
  const [show, setShow] = useState(false);
  // const [reportYear, setReportYear] = useState(util.getCurrentRepotYear());

  const [reportYear, setReportYear] = useState([minYear, maxYear]);
  const [reportOutProps, setReportOutProps] = useState({
    data: [],
    color: "",
    type: "",
    year: 0,
    description: "",
    xLabel: "",
    yLabel: "",
    dataSource: "",
    seriesField: "",
    isStack: false,
    xField: "",
  });

  useEffect(() => {
    getPartnerTypes();
    getPartnerStatus();
    getPartnerLocality();
    getPartnerGrowth();
    preSelectYear();
  }, [minYear, maxYear]);


  const getPartnerTypes = async () => {
    try {
      const response = await ReportAPI.getPartnershipType();
      if (response) {
        const { data } = response;
        setPartnerType(data);
        setInitPartnerType(data);
      } else {
            setPartnerType([])
            setInitPartnerType([])
            }
          } catch (error) {
            setPartnerType([])
            setInitPartnerType([])
            recordError(error);
          }
  };

  const getPartnerStatus = async () => {
    try {
      const response = await ReportAPI.getPartnershipStatus();
      if (response) {
        const { data } = response;
        setPartnerStatus(data);
        setInitPartnerStatus(data);
        const uniqueYears = [... new Set(data.map(yr => yr.year))];
        const minValue = Math.min(...uniqueYears);
        const maxValue = Math.max(...uniqueYears);
        setMinYear(minValue);
        setMaxYear(maxValue);
        var values = "";
        uniqueYears.forEach((data) => {
          values = values.concat(data + ':"' + data + '",');
          const marks = eval('({' + values + '})');
          setSliderMarks(marks);
          setSliderEndIndex(uniqueYears.length);
        });
      } else {
            setPartnerStatus([])
            setInitPartnerStatus([])
            setMinYear()
            setMaxYear()
            setSliderMarks({})
            setSliderEndIndex()
            }
          } catch (error) {
            setPartnerStatus([])
            setInitPartnerStatus([])
            setMinYear()
            setMaxYear()
            setSliderMarks({})
            setSliderEndIndex()
            recordError(error);
          }
  };


  const getPartnerLocality = async () => {
    try {
      const response = await ReportAPI.getPartnershipLocality();
      if (response) {
        const { data } = response;
        setPartnerLocality(data);
        setInitPartnerLocality(data);
      } else {
            setPartnerLocality([])
            setInitPartnerLocality([])
            }
          } catch (error) {
            setPartnerLocality([])
            setInitPartnerLocality([])
            recordError(error);
          }
  };

  const getPartnerGrowth = async () => {
    try {
      const response = await ReportAPI.getPartnershipGrowth();
      if (response) {
        const { data } = response;
        setPartnerGrowth(data);
      } else {
            setPartnerGrowth([])
            }
          } catch (error) {
            setPartnerGrowth([])
            recordError(error);
          }
  };

  const onChange = (value) => {

    setSliderStartIndex(value[0]);
    setSliderEndIndex(value[1]);

    updatePartnerType(value);
    updatePartnerStatus(value);
    updatePartnerLocality(value);

    setReportYear(value);
  };

  const preSelectYear = () => {

    if (minYear && maxYear) {
      setReportYear([minYear, maxYear]);
    }
    else {
      setReportYear(util.getCurrentRepotYear());
    }
  };

  const selectedRepYear = () => {

    var selectedYear;
    if (reportYear[0] === reportYear[1]) {
      selectedYear = reportYear[0];
    }
    else if (reportYear.length > 1) {
      selectedYear = `(${reportYear[0]} - ${reportYear[1]})`;
    }
    else {
      selectedYear = 0;
    }

    return selectedYear;
  }
  const updatePartnerType = (sliderData) => {
    const mn = sliderData[0];
    const mx = sliderData[1];
    const partners = initPartnerType.filter((partner) => partner.year >= mn && partner.year <= mx);
    setPartnerType(partners);
  };

  const updatePartnerStatus = (sliderData) => {
    const mn = sliderData[0];
    const mx = sliderData[1];
    const status = initPartnerStatus.filter((partner) => partner.year >= mn && partner.year <= mx);
    setPartnerStatus(status);
  };

  const updatePartnerLocality = (sliderData) => {
    const mn = sliderData[0];
    const mx = sliderData[1];
    const locality = initPartnerLocality.filter((partner) => partner.year >= mn && partner.year <= mx);
    setPartnerLocality(locality);
  };
  const handlePrint = (
    color,
    data,
    type,
    desc,
    title,
    xLabel = "None",
    yLabel = "None",
    seriesField = "None",
    isStack = false,
    xField = "None",
  ) => {
    const rptProps = { ...reportOutProps };
    rptProps.title = title;
    rptProps.description = desc;
    rptProps.color = color;
    rptProps.data = data;
    rptProps.type = type;
    // rptProps.year = reportYear ? reportYear : 0;
    rptProps.year = selectedRepYear();
    rptProps.xLabel = xLabel;
    rptProps.yLabel = yLabel;
    rptProps.seriesField = seriesField;
    rptProps.isStack = isStack;
    rptProps.xField = xField;

    setReportOutProps(rptProps);
    setShow(true);

  };

  const handleDataDownload = (data, filename, chartType) => {
    let csvContent;

    try {
      if (chartType === reportTypeEnum.GROUPCOL) {
        const groupedData = util.groupPartnerData(data, reportYear);

        csvContent =
          "data:text/csv;charset=utf-8," +
          util.convertArrayDataToCSV(groupedData);
        DownloadDataAsExcel(groupedData, filename);
      } else {
        csvContent =
          "data:text/csv;charset=utf-8," + util.convertArrayDataToCSV(data);
        DownloadDataAsExcel(data, filename);
      }

      //!  No longer allowing csv file download according to new requirements from business

      // const encodedURI = encodeURI(csvContent);

      // //Allow the selected to be downloadable through an anchor popup
      // const link = document.createElement("a");
      // link.setAttribute("href", encodedURI);
      // link.setAttribute("download", filename);
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
    } catch (error) {
      recordError(error)
    }
  };

  const handlePrintCancel = () => {
    setShow(false);
  };

  return (

    <div className="report-content partnership">
      <h2 className="report-heading">Partnership Report</h2>

      {partnerStatus.length > 0 &&
        <Row style={{ paddingBottom: 10 }} justify="center" align="middle">
          <Col xs={24} sm={20} md={16} className="date-slider">
            <Slider
              trackStyle={{ backgroundColor: "#19406a" }}
              handleStyle={{ borderColor: "#000000" }}
              marks={sliderMarks}
              range="true"
              onChange={onChange}
              min={minYear}
              max={maxYear}
              defaultValue={[sliderStartIndex, sliderEndIndex - 1]}
            />
          </Col>
        </Row>
      }
      <Row>
        <Col span={6} xs={{ order: 1, span: 24}} sm={{ order: 1, span: 24 }} md={{ order: 2, span: 6  }} lg={{ order: 2, span: 6 }}>
        {/* md={{span: 6, pull: 18}} */}
          <Row gutter={0} className="parnership-icons">
            <Col xs={24} sm={12} md={22}>
              <Card className="green"
                bordered={false}
              >
                <Row>
                  <Col span={16}>
                    <h3>Active Partners</h3>
                    <div>{partnerGrowth.active}</div>
                  </Col>
                  <Col span={8}>
                    <img src={require("../../assets/parnerships-active.png")} />
                  </Col>
                </Row>

              </Card>
            </Col>
            <Col xs={24} sm={12} md={22}>
              <Card className="blue1"
                bordered={false}
              >

                <Row>
                  <Col span={16}>
                    <h3>Local Partners</h3>
                    <div>{partnerGrowth.local}</div>
                  </Col>
                  <Col span={8}>
                    <img src={require("../../assets/parnerships-local.png")} />
                  </Col>
                </Row>

              </Card>
            </Col>
            <Col xs={24} sm={12} md={22}>
              <Card className="blue2"
                bordered={false}
              >
                <Row>
                  <Col span={16}>
                    <h3>Foreign Partners</h3>
                    <div>{partnerGrowth.foreign}</div>
                  </Col>
                  <Col span={8}>
                    <img src={require("../../assets/parnerships-foreign.png")} />
                  </Col>
                </Row>

              </Card>
            </Col>
            <Col xs={24} sm={12} md={22}>
              <Card className="purple1"
                bordered={false}
              >
                <Row>
                  <Col span={16}>
                    <h3>Public Partners</h3>
                    <div>{partnerGrowth.public}</div>
                  </Col>
                  <Col span={8}>
                    <img src={require("../../assets/parnerships-public.png")} />
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xs={24} sm={12} md={22}>
              <Card
                className="purple2"
                bordered={false}
              >
                <Row>
                  <Col span={16}>
                    <h3>Private Partners</h3>
                    <div>{partnerGrowth.private}</div>
                  </Col>
                  <Col span={8}>
                    <img src={require("../../assets/parnerships-private.png")} />
                  </Col>
                </Row>

              </Card>
            </Col>

          </Row>
        </Col>
        <Col span={18} xs={{ order: 2 , span: 24}} sm={{ order: 2 , span: 24 }} md={{ order: 1, span: 18  }} lg={{ order: 1 , span: 18 }}>
          <Row style={{ paddingBottom: 50 }} gutter={16}>

            <Col xs={24} md={24}>
              <Card
                title="Partnerships Growth and Retention"
                style={{ height: "auto" }}
                extra={
                  <Tooltip title='The total number of active partners and the percentage of active partners that remains the same over a number of years.'>
                    <InfoCircleTwoTone />
                  </Tooltip>
                }

                actions={
                  partnerStatus.length > 0 && [
                    <ReportButtons
                      onPrint={() =>
                        handlePrint(
                          "",
                          partnerStatus,
                          reportTypeEnum.DUALAXES,
                          "The total number of active partners and the percentage of active partners that remains the same over a number of years.",
                          "Partnerships Growth and Retention.",
                          "Year",
                          "",
                          "type",
                          true
                        )
                      }
                      onDownload={() =>
                        handleDataDownload(
                          partnerStatus,
                          "Partnerships Growth and Retention.",
                          reportTypeEnum.DUALAXES
                        )
                      }
                    />,
                  ]
                }
              >
                {partnerStatus.length === 0 ? <Empty /> : (
                  <DualAxesChart
                    data={partnerStatus.filter(item => item.value > 0)}
                    type="Partner"
                  />
                )}
              </Card>
            </Col>
          </Row>
          <Row style={{ paddingBottom: 50 }} gutter={16}>
            <Col xs={24} md={12}>
              <Card
                title="Local vs Foreign Partnerships"
                style={{ height: "auto" }}
                extra={
                  <Tooltip title='Total number of active partners filtered based on the country. E.g. South-Africa is local partnerships all other country partnerships are foreign.'>
                    <InfoCircleTwoTone />
                  </Tooltip>
                }

                actions={
                  partnerLocality.length > 0 && [
                    <ReportButtons
                      onPrint={() =>
                        handlePrint(
                          "Local",
                          partnerLocality,
                          reportTypeEnum.GROUPCOL,
                          "Total number of active partners filtered based on the country. E.g. South-Africa is local partnerships all other country partnerships are foreign.",
                          "Local vs Foreign Partnerships",
                          "Year",
                          "No of Partners",
                          "type",
                          true,
                          "year"
                        )
                      }
                      onDownload={() =>
                        handleDataDownload(
                          partnerLocality,
                          "Local vs Foreign Partnerships",
                          reportTypeEnum.GROUPCOL
                        )
                      }
                    />,
                  ]
                }
              >
                {partnerLocality.length === 0 ? <Empty /> : (
                  <StackColumnChart
                    data={partnerLocality.filter(item => item.value > 0)}
                    color='Local'
                    xField="year"
                    yLabel="value"
                    xAxisLabel="Year"
                    yAxisLabel="No of Partners"
                    series="type"
                    isStack={true}
                  />
                )}
              </Card>
            </Col >
            <Col xs={24} md={12}>
              <Card
                title="Public vs Private Partnerships"
                style={{ height: "auto" }}
                extra={
                  <Tooltip title='Total number of active partners filtered based on the value of the partner type. E.g. Government Department and State owned is public, and Private is private.'>
                    <InfoCircleTwoTone />
                  </Tooltip>
                }

                actions={
                  partnerType.length > 0 && [
                    <ReportButtons
                      onPrint={() =>
                        handlePrint(
                          "Public",
                          partnerType,
                          reportTypeEnum.GROUPCOL,
                          "Public vs Private Partnerships",
                          "Total number of active partners filtered based on the value of the partner type. E.g. Government Department and State owned is public, and Private is private.",
                          "Year",
                          "No of Partners",
                          "type",
                          true,
                          "year"
                        )
                      }
                      onDownload={() =>
                        handleDataDownload(
                          partnerType,
                          "Public vs Private Partnerships",
                          reportTypeEnum.GROUPCOL
                        )
                      }
                    />,
                  ]
                }
              >
                {partnerType.length === 0 ? <Empty /> : (
                  <StackColumnChart
                    data={partnerType.filter(item => item.value > 0)}
                    color='Public'
                    xField="year"
                    yLabel="value"
                    xAxisLabel="Year"
                    yAxisLabel="No of Partners"
                    series="type"
                    isStack={true}
                  />
                )}
              </Card>
            </Col>

            <Col xs={24} md={6}></Col>
          </Row>
        </Col>
      </Row>
      <ReportTemplatePartner
        onCancel={handlePrintCancel}
        reportOutProps={reportOutProps}
        show={show}
        key="reportPartnersParticipants"
        isGeo={false}
      />
    </div>
  )
}